import { __assign } from "tslib";
var LayoutsStore = /** @class */ (function () {
    function LayoutsStore() {
    }
    Object.defineProperty(LayoutsStore.prototype, "layout", {
        get: function () {
            return this._layout;
        },
        set: function (_layout) {
            this._layout = __assign({}, _layout);
        },
        enumerable: false,
        configurable: true
    });
    return LayoutsStore;
}());
export default new LayoutsStore();
//# sourceMappingURL=layoutsStore.js.map